import { useEffect } from "react";
import "./App.css";

function App() {
  useEffect(() => {
    console.log("Le client a démarré avec succès");
  }, []);

  const shortUrl =
    window.location.pathname.replace(/^\//, "").length > 0
      ? window.location.host + window.location.pathname
      : "clyx.sms/xK9p2";

  return (
    <div className="App">
      {/* BG */}
      <div className="bg-layer">
        <div className="orb orb-1"></div>
        <div className="orb orb-2"></div>
        <div className="hero-grid"></div>
      </div>

      {/* HEADER */}
      <header>
        <div className="header-left">
          <img
            src="https://clyxsms.agencelycs.com/images/logo-clyx.png"
            width="60"
            alt="Clyx SMS Logo"
            className="logo-img"
          />
          {/* <span className="header-tag">URL Shortener</span> */}
        </div>
        <div className="header-right">
          <a href="https://www.agencelycs.com">Lycs Agency →</a>
        </div>
      </header>

      {/* MAIN */}
      <main>
        {/* Visual error */}
        <div className="error-visual">
          <div className="ring-wrap">
            <svg
              className="ring-outer"
              viewBox="0 0 340 340"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="170"
                cy="170"
                r="160"
                stroke="rgba(209,0,144,0.12)"
                strokeWidth="1"
                strokeDasharray="8 14"
                fill="none"
              />
              <circle
                cx="170"
                cy="170"
                r="140"
                stroke="rgba(209,0,144,0.07)"
                strokeWidth="1"
                strokeDasharray="3 20"
                fill="none"
              />
            </svg>
            <svg className="ring-inner" viewBox="0 0 240 240" fill="none">
              <circle
                cx="120"
                cy="120"
                r="110"
                stroke="rgba(255,60,172,0.1)"
                strokeWidth="1"
                strokeDasharray="5 10"
                fill="none"
              />
            </svg>
          </div>

          <div className="error-code-wrap">
            <div className="error-code" data-text="404">
              404
            </div>
            <div className="error-badge">🔗</div>
          </div>
        </div>

        {/* Labels */}
        <div className="error-tag">LIEN INVALIDE</div>

        <h1 className="error-title">
          Ce lien <span className="gradient-text">n'existe pas</span>
          <br />
          ou a expiré
        </h1>

        <p className="error-desc">
          L'URL raccourcie que vous avez suivie est introuvable dans notre
          système. Elle a peut-être été désactivée, supprimée ou n'a jamais
          existé.
        </p>
      </main>

      {/* FOOTER */}
      <footer>
        <div className="footer-bottom">
          <span>© 2025 Clyx SMS - URL Shortener</span>
          <span>
            Propulsé par{" "}
            <a
              href="https://www.agencelycs.com"
              target="_blank"
              rel="noreferrer"
            >
              Lycs Agency
            </a>
          </span>
        </div>
      </footer>
    </div>
  );
}

export default App;
